/*
 * Dropshipping (Genovese): un'azienda fa spedire l'ordine direttamente a un suo cliente.
 *
 * - Un ordine Shopify ha un solo indirizzo di spedizione: quello del cliente vale per
 *   tutto il carrello, e i riquadri lo dicono.
 * - L'indirizzo si salva sul carrello con la Storefront API, che per il carrello non chiede
 *   token: indirizzo di consegna «selezionato» (il checkout lo trova già inserito) e «monouso»
 *   (dopo l'ordine non resta nella rubrica dell'azienda). Per l'Italia la validazione è STRICT:
 *   CAP, provincia e civico si controllano qui con le regole del checkout e gli errori
 *   compaiono nel modulo.
 * - Due attributi del carrello restano nell'ordine (admin → Dettagli aggiuntivi):
 *   «Dropshipping: Sì» per il magazzino e per Shopify Flow, «Destinatario dropshipping»
 *   con l'indirizzo come è stato inserito.
 * - Col carrello vuoto l'indirizzo resta in attesa (sessionStorage: solo questa scheda del
 *   browser, così un vecchio indirizzo non finisce in un ordine di giorni dopo) e si applica
 *   appena si aggiunge un prodotto.
 *
 * Markup: snippets/gm-dropshipping.liquid (riquadri), snippets/gm-dropshipping-modulo.liquid (finestra).
 */
(() => {
  if (window.gmDropshipping) return;
  const datiEl = document.getElementById('GmDropshipping-Dati');
  const dialog = document.getElementById('GmDropshipping');
  if (!datiEl || !dialog) return;

  const dati = JSON.parse(datiEl.textContent);
  const testi = dati.testi;
  const API = '/api/2026-10/graphql.json';
  const ATTRIBUTO_FLAG = 'Dropshipping';
  const ATTRIBUTO_DESTINATARIO = 'Destinatario dropshipping';
  const SI = 'Sì';
  const CHIAVE_ATTESA = 'gm-dropshipping-attesa';
  const LINGUE_API = ['IT', 'EN', 'RO', 'PL', 'DE', 'FR', 'ES'];

  // Province di Shopify (github.com/Shopify/worldwide, data/regions/IT.yml): codice|nome|prefissi CAP.
  // Sono quelle che il checkout accetta, comprese le vecchie province sarde (OT, VS, OG, CI).
  const PROVINCE = (
    'AG|Agrigento|92;AL|Alessandria|15;AN|Ancona|60;AO|Aosta|11;AR|Arezzo|52;' +
    'AP|Ascoli Piceno|630 631;AT|Asti|14;AV|Avellino|83;BA|Bari|70;BT|Barletta-Andria-Trani|76;' +
    'BL|Belluno|32;BN|Benevento|82;BG|Bergamo|24;BI|Biella|138 139;BO|Bologna|40;BZ|Bolzano|39;' +
    'BS|Brescia|25;BR|Brindisi|72;' +
    'CA|Cagliari|08033 08035 09012 09018 09019 09023 09024 09026 09028 09032 09033 09034 09040 09041 09042 09043 09044 09045 09047 09048 09049 0905 09060 09061 09062 09063 09065 09066 09067 09068 09069 0910 0912 0913;' +
    'CL|Caltanissetta|93;CB|Campobasso|8601 8602 8603 8604 8610;CE|Caserta|81;CT|Catania|95;' +
    'CZ|Catanzaro|880 881;CH|Chieti|66;CO|Como|22;CS|Cosenza|87;CR|Cremona|260 261;' +
    'KR|Crotone|888 889;CN|Cuneo|12;EN|Enna|94;FM|Fermo|638 639;FE|Ferrara|44;FI|Firenze|50;' +
    'FG|Foggia|71;FC|Forlì-Cesena|470 471 475;FR|Frosinone|03;' +
    'OT|Gallura Nord-Est Sardegna|0702 07030 07038 07051 07052;GE|Genova|16;GO|Gorizia|3407 3417;' +
    'GR|Grosseto|58;IM|Imperia|18;IS|Isernia|8607 8608 8609 8617;AQ|L\'Aquila|67;SP|La Spezia|19;' +
    'LT|Latina|04;LE|Lecce|73;LC|Lecco|238 239;LI|Livorno|57;LO|Lodi|268 269;LU|Lucca|55;' +
    'MC|Macerata|62;MN|Mantova|46;MS|Massa-Carrara|54;MT|Matera|75;' +
    'VS|Medio Campidano|09020 09021 09022 09025 09027 09029 09030 09031 09035 09036 09037 09038 09039;' +
    'ME|Messina|98;MI|Milano|200 201;MO|Modena|41;MB|Monza e Brianza|208 209;NA|Napoli|80;' +
    'NO|Novara|280 281;' +
    'NU|Nuoro|08011 08012 08015 08016 08017 08018 0802 08030 08031 08032 08036 08037 08038 08039 081;' +
    'OG|Ogliastra|08040 08042 08044 08045 08046 08047 08048 08049 09064;' +
    'OR|Oristano|08010 08013 08019 0907 0908 0909 0917;PD|Padova|35;PA|Palermo|90;PR|Parma|43;' +
    'PV|Pavia|27;PG|Perugia|06;PU|Pesaro e Urbino|61;PE|Pescara|65;PC|Piacenza|29;PI|Pisa|56;' +
    'PT|Pistoia|51;PN|Pordenone|3307 3308 3309 3317;PZ|Potenza|85;PO|Prato|59;RG|Ragusa|97;' +
    'RA|Ravenna|48;RC|Reggio Calabria|890 891;RE|Reggio Emilia|42;RI|Rieti|02;RN|Rimini|478 479;' +
    'RM|Roma|000 0010 0011 00121 00122 00123 00124 00125 00126 00127 00128 00129 0013 0014 0015 0016 0017 0018 0019;' +
    'RO|Rovigo|45;SA|Salerno|84;' +
    'SS|Sassari|0701 07031 07032 07033 07034 07035 07036 07037 07039 0704 07100;SV|Savona|17;' +
    'SI|Siena|53;SR|Siracusa|96;SO|Sondrio|230 231;' +
    'CI|Sulcis Iglesiente|09010 09011 09013 09014 09015 09016 09017;TA|Taranto|74;TE|Teramo|64;' +
    'TR|Terni|05;TO|Torino|10;TP|Trapani|91;TN|Trento|38;TV|Treviso|31;' +
    'TS|Trieste|3401 3410 3412 3413 3414 3415;UD|Udine|3301 3302 3303 3304 3305 3306 3310;' +
    'VA|Varese|21;VE|Venezia|30;VB|Verbano-Cusio-Ossola|288 289;VC|Vercelli|130 131;VR|Verona|37;' +
    'VV|Vibo Valentia|898 899;VI|Vicenza|36;VT|Viterbo|01'
  )
    .split(';')
    .map((riga) => {
      const [codice, nome, prefissi] = riga.split('|');
      return { codice, nome, prefissi: prefissi.split(' ') };
    });

  // Prefissi telefonici dei paesi in cui spedisce il negozio (Italia e Unione europea).
  const PREFISSI_TELEFONO = {
    AT: '43', BE: '32', BG: '359', CY: '357', CZ: '420', DE: '49', DK: '45', EE: '372', ES: '34',
    FI: '358', FR: '33', GR: '30', HR: '385', HU: '36', IE: '353', IT: '39', LT: '370', LU: '352',
    LV: '371', MT: '356', NL: '31', PL: '48', PT: '351', RO: '40', SE: '46', SI: '386', SK: '421',
  };

  /* ── Stato ───────────────────────────────────────────────────────── */
  let stato = { attivo: dati.attivo, riepilogo: dati.riepilogo || '', inAttesa: false };

  function leggiAttesa() {
    try {
      return JSON.parse(sessionStorage.getItem(CHIAVE_ATTESA) || 'null');
    } catch (errore) {
      return null;
    }
  }

  function scriviAttesa(valore) {
    try {
      if (valore) sessionStorage.setItem(CHIAVE_ATTESA, JSON.stringify(valore));
      else sessionStorage.removeItem(CHIAVE_ATTESA);
    } catch (errore) {
      // Navigazione privata o archiviazione bloccata: l'indirizzo in attesa vale solo per questa pagina.
    }
  }

  const attesaIniziale = leggiAttesa();
  if (attesaIniziale) stato = { attivo: true, riepilogo: attesaIniziale.riepilogo, inAttesa: true };

  function imposta(nuovo) {
    stato = nuovo;
    document.querySelectorAll('gm-dropshipping-stato').forEach((riquadro) => riquadro.aggiorna());
  }

  function annuncia(testo) {
    const regione = document.getElementById('GmDropshipping-Annuncio');
    if (!regione) return;
    regione.textContent = '';
    setTimeout(() => (regione.textContent = testo), 100);
  }

  /* ── Carrello e Storefront API ───────────────────────────────────── */
  async function carrello() {
    const risposta = await fetch(`${window.routes?.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } });
    if (!risposta.ok) throw new Error(`cart.js ${risposta.status}`);
    return risposta.json();
  }

  // Il token di /cart.js ha già la chiave (…?key=…), che la Storefront API vuole per i dati del cliente.
  function idCarrello(token) {
    return token.startsWith('gid://') ? token : `gid://shopify/Cart/${token}`;
  }

  async function graphql(query, variabili) {
    const risposta = await fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ query, variables: variabili }),
    });
    const json = await risposta.json().catch(() => ({}));
    if (!risposta.ok || json.errors) throw new Error(`Storefront API: ${JSON.stringify(json.errors || risposta.status)}`);
    return json.data;
  }

  const CAMPI_INDIRIZZO = 'firstName lastName company address1 address2 city provinceCode zip countryCode phone';

  const SALVA = `mutation GmDropshippingSalva($cartId: ID!, $indirizzi: [CartSelectableAddressInput!]!, $lingua: LanguageCode)
    @inContext(language: $lingua) {
    cartDeliveryAddressesReplace(cartId: $cartId, addresses: $indirizzi) {
      cart { id }
      userErrors { field message code }
    }
  }`;

  const LEGGI = `query GmDropshippingLeggi($cartId: ID!) {
    cart(id: $cartId) {
      delivery { addresses { id selected oneTimeUse address { ... on CartDeliveryAddress { ${CAMPI_INDIRIZZO} } } } }
    }
  }`;

  const TOGLI = `mutation GmDropshippingTogli($cartId: ID!, $ids: [ID!]!) {
    cartDeliveryAddressesRemove(cartId: $cartId, addressIds: $ids) {
      userErrors { field message code }
    }
  }`;

  // Errori della API sul campo (es. ["addresses","0","address","deliveryAddress","zip"]) → nome del campo nel modulo.
  function campoDaErrore(percorso) {
    const ultimo = Array.isArray(percorso) ? percorso[percorso.length - 1] : '';
    return CAMPI_INDIRIZZO.split(' ').includes(ultimo) ? ultimo : null;
  }

  async function applicaAlCarrello(cart, indirizzo) {
    const cartId = idCarrello(cart.token);
    const risultato = await graphql(SALVA, {
      cartId,
      ...(LINGUE_API.includes(dati.lingua) ? { lingua: dati.lingua } : {}),
      indirizzi: [
        {
          selected: true,
          oneTimeUse: true,
          validationStrategy: indirizzo.countryCode === 'IT' ? 'STRICT' : 'COUNTRY_CODE_ONLY',
          address: { deliveryAddress: indirizzo },
        },
      ],
    });
    const esito = risultato.cartDeliveryAddressesReplace;
    if (esito.userErrors.length) {
      return esito.userErrors.map((errore) => ({ campo: campoDaErrore(errore.field), messaggio: errore.message }));
    }
    // Senza la chiave giusta Shopify scriverebbe su un carrello nuovo: il checkout non vedrebbe l'indirizzo.
    if (!esito.cart || esito.cart.id.split('?')[0] !== cartId.split('?')[0]) {
      throw new Error(`Storefront API: carrello diverso (${esito.cart && esito.cart.id})`);
    }
    return [];
  }

  async function scriviAttributi(riepilogo) {
    const risposta = await fetch(`${window.routes?.cart_update_url || '/cart/update'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        attributes: { [ATTRIBUTO_FLAG]: riepilogo ? SI : '', [ATTRIBUTO_DESTINATARIO]: riepilogo || '' },
      }),
    });
    if (!risposta.ok) throw new Error(`cart/update.js ${risposta.status}`);
  }

  async function indirizzoSulCarrello(cart) {
    const risultato = await graphql(LEGGI, { cartId: idCarrello(cart.token) });
    const indirizzi = risultato.cart?.delivery?.addresses || [];
    return indirizzi.filter((voce) => voce.oneTimeUse);
  }

  /* ── Azioni ──────────────────────────────────────────────────────── */
  async function salva(indirizzo) {
    const riepilogo = componiRiepilogo(indirizzo);
    const cart = await carrello();
    if (!cart.item_count) {
      scriviAttesa({ indirizzo, riepilogo });
      imposta({ attivo: true, riepilogo, inAttesa: true });
      return [];
    }
    const errori = await applicaAlCarrello(cart, indirizzo);
    if (errori.length) return errori;
    await scriviAttributi(riepilogo);
    scriviAttesa(null);
    imposta({ attivo: true, riepilogo, inAttesa: false });
    return [];
  }

  async function applicaAttesa() {
    const attesa = leggiAttesa();
    if (!attesa) return;
    const cart = await carrello();
    if (!cart.item_count) return;
    const errori = await applicaAlCarrello(cart, attesa.indirizzo);
    if (errori.length) {
      // L'indirizzo non passa i controlli del checkout: esce dall'attesa (così non si ripropone a ogni
      // aggiunta al carrello) e il modulo si riapre una volta con gli errori. Salvando, ora si applica subito.
      scriviAttesa(null);
      imposta({ attivo: false, riepilogo: '', inAttesa: false });
      modulo.apri(null, attesa.indirizzo, errori);
      return;
    }
    await scriviAttributi(attesa.riepilogo);
    scriviAttesa(null);
    imposta({ attivo: true, riepilogo: attesa.riepilogo, inAttesa: false });
  }

  async function rimuovi() {
    scriviAttesa(null);
    const cart = await carrello();
    if (cart.item_count || cart.attributes?.[ATTRIBUTO_FLAG]) {
      const nostri = await indirizzoSulCarrello(cart);
      if (nostri.length) {
        const risultato = await graphql(TOGLI, { cartId: idCarrello(cart.token), ids: nostri.map((voce) => voce.id) });
        if (risultato.cartDeliveryAddressesRemove.userErrors.length) {
          throw new Error(`Storefront API: ${JSON.stringify(risultato.cartDeliveryAddressesRemove.userErrors)}`);
        }
      }
      await scriviAttributi(null);
    }
    imposta({ attivo: false, riepilogo: '', inAttesa: false });
  }

  async function indirizzoAttuale() {
    const attesa = leggiAttesa();
    if (attesa) return attesa.indirizzo;
    if (!stato.attivo) return null;
    const cart = await carrello();
    const nostri = await indirizzoSulCarrello(cart);
    const scelto = nostri.find((voce) => voce.selected) || nostri[0];
    return scelto ? scelto.address : null;
  }

  /* ── Formati ─────────────────────────────────────────────────────── */
  function nomePaese(codice) {
    return (dati.paesi && dati.paesi[codice]) || codice;
  }

  // Una riga, come la legge il magazzino nell'ordine: «Mario Rossi (Rossi Srl), Via Po 10, 10123 Torino (TO) · Tel. +39…».
  function componiRiepilogo(indirizzo) {
    const nome = [indirizzo.firstName, indirizzo.lastName].filter(Boolean).join(' ');
    const chi = indirizzo.company ? `${nome} (${indirizzo.company})` : nome;
    const luogo =
      [indirizzo.zip, indirizzo.city].filter(Boolean).join(' ') + (indirizzo.provinceCode ? ` (${indirizzo.provinceCode})` : '');
    const paese = indirizzo.countryCode === 'IT' ? '' : nomePaese(indirizzo.countryCode);
    const riga = [chi, indirizzo.address1, indirizzo.address2, luogo, paese].filter(Boolean).join(', ');
    return indirizzo.phone ? `${riga} · Tel. ${indirizzo.phone}` : riga;
  }

  function normalizzaTelefono(valore, paese) {
    let numero = valore.replace(/[\s().\-/]/g, '');
    if (numero.startsWith('00')) numero = `+${numero.slice(2)}`;
    // Fuori dall'Italia lo 0 iniziale del numero nazionale cade col prefisso (030… → +4930…); in Italia resta (06… → +3906…).
    if (!numero.startsWith('+') && paese !== 'IT') numero = numero.replace(/^0/, '');
    if (!numero.startsWith('+')) numero = `+${PREFISSI_TELEFONO[paese] || '39'}${numero}`;
    return /^\+\d{8,15}$/.test(numero) ? numero : null;
  }

  function provinciaDaCap(cap) {
    let migliore = null;
    PROVINCE.forEach((provincia) => {
      provincia.prefissi.forEach((prefisso) => {
        if (cap.startsWith(prefisso) && (!migliore || prefisso.length > migliore.lunghezza)) {
          migliore = { codice: provincia.codice, lunghezza: prefisso.length };
        }
      });
    });
    return migliore && migliore.codice;
  }

  /* ── Finestra ────────────────────────────────────────────────────── */
  const modulo = {
    form: dialog.querySelector('[data-gm-ds-form]'),
    errori: dialog.querySelector('[data-gm-ds-errori]'),
    salvaPulsante: dialog.querySelector('[data-gm-ds-salva]'),
    pronto: false,
    origine: null,

    prepara() {
      if (this.pronto) return;
      this.pronto = true;
      const paese = this.form.elements.countryCode;
      const codici = dati.estero ? Object.keys(dati.paesi) : [];
      if (!codici.includes('IT')) codici.unshift('IT');
      codici
        .sort((a, b) => (a === 'IT' ? -1 : b === 'IT' ? 1 : nomePaese(a).localeCompare(nomePaese(b))))
        .forEach((codice) => paese.add(new Option(nomePaese(codice), codice)));
      dialog.querySelector('[data-gm-ds-voce="countryCode"]').hidden = codici.length < 2;

      const provincia = this.form.elements.provinceCode;
      provincia.add(new Option(testi.provinciaScegli, ''));
      PROVINCE.forEach((voce) => provincia.add(new Option(`${voce.nome} (${voce.codice})`, voce.codice)));

      this.form.addEventListener('submit', (evento) => this.invia(evento));
      paese.addEventListener('change', () => this.aggiornaPaese());
      provincia.addEventListener('change', () => delete provincia.dataset.auto);
      this.form.elements.zip.addEventListener('input', () => this.suggerisciProvincia());
      dialog.querySelectorAll('[data-gm-ds-chiudi]').forEach((pulsante) =>
        pulsante.addEventListener('click', () => dialog.close())
      );
      // Clic sullo sfondo (fuori dal riquadro) = chiudi.
      dialog.addEventListener('click', (evento) => {
        if (evento.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => this.restituisciFocus());
    },

    async apri(origine, indirizzo = null, errori = []) {
      this.prepara();
      this.origine = origine;
      this.form.reset();
      delete this.form.elements.provinceCode.dataset.auto;
      this.pulisciErrori();
      this.aggiornaPaese();
      if (!dialog.open) dialog.showModal();
      if (indirizzo) {
        this.compila(indirizzo);
      } else if (stato.attivo) {
        this.occupato(true);
        try {
          const attuale = await indirizzoAttuale();
          if (attuale) this.compila(attuale);
        } catch (errore) {
          console.error('[gm-dropshipping]', errore);
        } finally {
          this.occupato(false);
        }
      }
      if (errori.length) this.mostraErrori(errori);
      else this.form.elements.firstName.focus();
    },

    compila(indirizzo) {
      Object.entries(indirizzo).forEach(([campo, valore]) => {
        const elemento = this.form.elements[campo];
        if (!elemento || valore == null) return;
        elemento.value = valore;
        if (campo === 'countryCode') this.aggiornaPaese();
      });
      // Provincia coerente col CAP: se poi si cambia il CAP, la provincia lo segue.
      const provincia = this.form.elements.provinceCode;
      if (provincia.value && provincia.value === provinciaDaCap(this.form.elements.zip.value.trim())) {
        provincia.dataset.auto = 'true';
      }
    },

    aggiornaPaese() {
      const italia = (this.form.elements.countryCode.value || 'IT') === 'IT';
      const voce = dialog.querySelector('[data-gm-ds-voce="provinceCode"]');
      voce.hidden = !italia;
      this.form.elements.provinceCode.disabled = !italia;
      this.form.elements.zip.inputMode = italia ? 'numeric' : 'text';
    },

    suggerisciProvincia() {
      const provincia = this.form.elements.provinceCode;
      const cap = this.form.elements.zip.value.trim();
      if (provincia.disabled || !/^\d{5}$/.test(cap)) return;
      if (provincia.value && !provincia.dataset.auto) return;
      const codice = provinciaDaCap(cap);
      if (!codice) return;
      provincia.value = codice;
      provincia.dataset.auto = 'true';
    },

    leggiCampi() {
      const valori = new FormData(this.form);
      const testo = (campo) => (valori.get(campo) || '').toString().trim().replace(/\s+/g, ' ');
      const indirizzo = {
        countryCode: testo('countryCode') || 'IT',
        firstName: testo('firstName'),
        lastName: testo('lastName'),
        company: testo('company'),
        address1: testo('address1'),
        address2: testo('address2'),
        zip: testo('zip').toUpperCase(),
        city: testo('city'),
        provinceCode: testo('provinceCode'),
        phone: testo('phone'),
      };
      if (indirizzo.countryCode !== 'IT') indirizzo.provinceCode = '';
      return indirizzo;
    },

    valida(indirizzo) {
      const errori = [];
      const italia = indirizzo.countryCode === 'IT';
      ['firstName', 'lastName', 'address1', 'zip', 'city', 'phone'].forEach((campo) => {
        if (!indirizzo[campo]) errori.push({ campo, messaggio: testi.obbligatorio });
      });
      if (italia && !indirizzo.provinceCode) errori.push({ campo: 'provinceCode', messaggio: testi.obbligatorio });
      if (italia && indirizzo.address1 && !/\d|\bsnc\b/i.test(indirizzo.address1)) {
        errori.push({ campo: 'address1', messaggio: testi.civico });
      }
      if (italia && indirizzo.zip && !/^\d{5}$/.test(indirizzo.zip)) errori.push({ campo: 'zip', messaggio: testi.cap });
      if (indirizzo.phone) {
        const telefono = normalizzaTelefono(indirizzo.phone, indirizzo.countryCode);
        if (telefono) indirizzo.phone = telefono;
        else errori.push({ campo: 'phone', messaggio: testi.telefono });
      }
      return errori;
    },

    async invia(evento) {
      evento.preventDefault();
      if (this.salvaPulsante.disabled) return;
      this.pulisciErrori();
      const indirizzo = this.leggiCampi();
      const errori = this.valida(indirizzo);
      if (errori.length) {
        this.mostraErrori(errori);
        return;
      }
      // Campi facoltativi vuoti: non si mandano alla API.
      Object.keys(indirizzo).forEach((campo) => {
        if (!indirizzo[campo]) delete indirizzo[campo];
      });

      this.occupato(true, testi.salvataggio);
      try {
        const rifiuti = await salva(indirizzo);
        if (rifiuti.length) {
          this.mostraErrori(rifiuti);
          return;
        }
        dialog.close();
        annuncia(testi.salvato);
      } catch (errore) {
        console.error('[gm-dropshipping]', errore);
        this.mostraErrori([{ campo: null, messaggio: testi.generico }]);
      } finally {
        this.occupato(false);
      }
    },

    occupato(attivo, etichetta) {
      this.salvaPulsante.disabled = attivo;
      this.salvaPulsante.classList.toggle('loading', attivo);
      this.salvaPulsante.querySelector('.loading__spinner')?.classList.toggle('hidden', !attivo);
      this.salvaPulsante.setAttribute('aria-busy', attivo ? 'true' : 'false');
      if (etichetta) annuncia(etichetta);
    },

    pulisciErrori() {
      this.errori.hidden = true;
      this.errori.textContent = '';
      dialog.querySelectorAll('.gm-ds-modulo__errore').forEach((elemento) => {
        elemento.hidden = true;
        elemento.textContent = '';
      });
      dialog.querySelectorAll('[aria-invalid]').forEach((elemento) => elemento.removeAttribute('aria-invalid'));
    },

    mostraErrori(errori) {
      let primo = null;
      const generici = [];
      errori.forEach(({ campo, messaggio }) => {
        const elemento = campo && this.form.elements[campo];
        const spazio = campo && document.getElementById(`GmDs-${campo}-errore`);
        if (!elemento || !spazio || elemento.disabled) {
          generici.push(messaggio);
          return;
        }
        elemento.setAttribute('aria-invalid', 'true');
        spazio.textContent = messaggio;
        spazio.hidden = false;
        primo = primo || elemento;
      });
      if (generici.length || !primo) {
        this.errori.textContent = generici.length ? generici.join(' ') : testi.controlla;
        this.errori.hidden = false;
      }
      if (primo) primo.focus();
      else this.errori.scrollIntoView({ block: 'nearest' });
    },

    // Il pulsante che ha aperto la finestra può essere sparito (l'invito diventa «indirizzo attivo»):
    // il focus va al pulsante equivalente dello stesso riquadro.
    restituisciFocus() {
      const riquadro = this.origine && this.origine.closest('gm-dropshipping-stato');
      this.origine = null;
      if (!riquadro || !riquadro.isConnected) return;
      const destinazione = stato.attivo
        ? riquadro.querySelector('[data-gm-ds-attivo] [data-gm-ds-apri]')
        : riquadro.querySelector('[data-gm-ds-invito] [data-gm-ds-apri], [data-gm-ds-invito][data-gm-ds-apri]');
      if (destinazione) requestAnimationFrame(() => destinazione.focus());
    },
  };

  /* ── Riquadri ────────────────────────────────────────────────────── */
  if (!customElements.get('gm-dropshipping-stato')) {
    customElements.define(
      'gm-dropshipping-stato',
      class GmDropshippingStato extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', this);
          this.aggiorna();
        }

        disconnectedCallback() {
          this.removeEventListener('click', this);
        }

        handleEvent(evento) {
          const apri = evento.target.closest('[data-gm-ds-apri]');
          if (apri) {
            evento.preventDefault();
            modulo.apri(apri);
            return;
          }
          const togli = evento.target.closest('[data-gm-ds-rimuovi]');
          if (togli) {
            evento.preventDefault();
            this.rimuovi(togli);
          }
        }

        async rimuovi(pulsante) {
          pulsante.disabled = true;
          try {
            await rimuovi();
            annuncia(testi.rimosso);
            const invito = this.querySelector('[data-gm-ds-invito] [data-gm-ds-apri], [data-gm-ds-invito][data-gm-ds-apri]');
            if (invito) invito.focus();
          } catch (errore) {
            console.error('[gm-dropshipping]', errore);
            // L'indirizzo resta sul carrello: va detto chiaramente, non solo al lettore di schermo.
            window.alert(testi.rimozione);
          } finally {
            pulsante.disabled = false;
          }
        }

        aggiorna() {
          this.querySelectorAll('[data-gm-ds-invito]').forEach((elemento) => (elemento.hidden = stato.attivo));
          this.querySelectorAll('[data-gm-ds-attivo]').forEach((elemento) => (elemento.hidden = !stato.attivo));
          this.querySelectorAll('[data-gm-ds-riepilogo]').forEach((elemento) => (elemento.textContent = stato.riepilogo));
          this.querySelectorAll('[data-gm-ds-nota-ordine]').forEach((elemento) => (elemento.hidden = stato.inAttesa));
          this.querySelectorAll('[data-gm-ds-nota-attesa]').forEach((elemento) => (elemento.hidden = !stato.inAttesa));
        }
      }
    );
  }

  /* ── Indirizzo in attesa: si applica al primo prodotto nel carrello ── */
  function provaAttesa() {
    if (leggiAttesa()) applicaAttesa().catch((errore) => console.error('[gm-dropshipping]', errore));
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, provaAttesa);
  }
  provaAttesa();

  window.gmDropshipping = { apri: (origine) => modulo.apri(origine || null), rimuovi, stato: () => ({ ...stato }) };
})();
